import {
  SwipeableDrawer,
  Typography,
  List,
  Box,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Grid,
  Paper,
  InputBase,
  IconButton,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import { PersonAdd, MonetizationOn, FeaturedPlayList, LocalOffer, Search, KeyboardBackspace } from '@mui/icons-material';
// import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
// import PaymentIcon from '@mui/icons-material/Payment';
// import PostAddIcon from '@mui/icons-material/PostAdd';
// import PersonAddIcon from '@mui/icons-material/PersonAdd';
// import GroupAddIcon from '@mui/icons-material/GroupAdd';
import ColorLensIcon from '@mui/icons-material/ColorLens';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import SummarizeOutlinedIcon from '@mui/icons-material/SummarizeOutlined';
import AssignmentIcon from '@mui/icons-material/Assignment';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import AddIcon from '@mui/icons-material/Add';
import SettingsIcon from '@mui/icons-material/Settings';
import BalanceIcon from '@mui/icons-material/Balance';
import ListAltIcon from '@mui/icons-material/ListAlt';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
// import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
// import PaymentIcon from '@mui/icons-material/Payment';
// import PostAddIcon from '@mui/icons-material/PostAdd';
// import PersonAddIcon from '@mui/icons-material/PersonAdd';
// import GroupAddIcon from '@mui/icons-material/GroupAdd';

import { Link, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useThemes } from '../../components/Theme/theme';
import { boolean } from 'yup';
import useControlledNavigation from '../../hooks/useControlledNavigation';
import SelectTheme from '../modals/SelectTheme';
import SupportPage from '../../pages/NewFigma/SupportPage';
import { useFeatureFlag } from '../../features/FeatureFlag';
import { showWarningSnackbar } from '../snackBar/snakbar';
import { settingsClose } from '../../redux/reducers/companySkipSave';
import { handleFreeze } from '../../utils/common';

function LinkDrawer({ linkDrawer, setLinkDrawer }) {
  const { theme } = useThemes();
  const dispatch = useDispatch();
  const [searchItem, setSearchItem] = useState('');
  const [expand, setExpand] = useState(false);
  const [accountsExpand, setAccountsExpand] = useState(false);
  const [supportOpen, setSupportOpen] = useState(false);
  const isItemImportEnabled = useFeatureFlag('itemimport');
  const isPartyImportEnabled = useFeatureFlag('partyimport');
  const isAccountImportEnabled = useFeatureFlag('accountimport');
  const { saveSkipStatus } = useSelector((state) => state.companySipSaveReducer);
  const importFreeze = useSelector((state) => state.userPrefrenceandReducer?.financialYear?.freezestatus);
  const isBankImportEnabled = useFeatureFlag('bankimport');

  const navigate = useControlledNavigation();

  const handleBulkImportClick = (item) => {
    if (importFreeze == 1) {
      handleFreeze();
      return;
    }
    if (saveSkipStatus === false) {
      showWarningSnackbar('Please Complete the Company Setup Details');
      dispatch(settingsClose());
      navigate('/companysetup');
      return;
    }
    if (item.navState) {
      navigate(item.nav, { state: item.navState });
    } else {
      navigate(item.nav);
    }
    setLinkDrawer(false);
  };

  // const general = [
  //   {
  //     menu: "Add User",
  //     title: (
  //       <Typography marginLeft={-4} fontSize={"14px"}>
  //         Add User
  //       </Typography>
  //     ),
  //     icon: (
  //       <PersonAdd
  //         sx={{
  //           color: theme?.palette?.TmId.id.toString().includes("9")
  //             ? ""
  //             : theme.palette.input.font,
  //           fontSize: "15px",
  //           margin: "0px",
  //         }}
  //       />
  //     ),
  //     nav: "",
  //   },
  //   {
  //     menu: "Journal Entry",
  //     title: (
  //       <Typography marginLeft={-4} fontSize={"14px"}>
  //         Journal Entry
  //       </Typography>
  //     ),
  //     icon: (
  //       <MonetizationOn
  //         sx={{
  //           color: theme?.palette?.TmId.id.toString().includes("9")
  //             ? ""
  //             : theme.palette.input.font,
  //           fontSize: "15px",
  //         }}
  //       />
  //     ),
  //     nav: "",
  //   },
  //   {
  //     menu: "Item",
  //     title: (
  //       <Typography marginLeft={-4} fontSize={"14px"}>
  //         Item
  //       </Typography>
  //     ),
  //     icon: (
  //       <FeaturedPlayList
  //         sx={{
  //           color: theme?.palette?.TmId.id.toString().includes("9")
  //             ? ""
  //             : theme.palette.input.font,
  //           fontSize: "15px",
  //         }}
  //       />
  //     ),
  //     nav: "",
  //   },
  //   {
  //     menu: "Log Time",
  //     title: (
  //       <Typography marginLeft={-4} fontSize={"14px"}>
  //         Log Time
  //       </Typography>
  //     ),
  //     icon: (
  //       <LocalOffer
  //         sx={{
  //           color: theme?.palette?.TmId.id.toString().includes("9")
  //             ? ""
  //             : theme.palette.input.font,
  //           fontSize: "15px",
  //         }}
  //       />
  //     ),
  //     nav: "",
  //   },
  // ];
  const sales = [
    {
      menu: 'Customer',
      label: 'Add Sales Invoice',
      title: (
        <Typography marginLeft={-4} fontSize={'14px'}>
          Add Sales Invoice
        </Typography>
      ),
      icon: (
        <AddIcon
          sx={{
            color: theme?.palette?.TmId.id.toString().includes('9') ? '' : theme.palette.input.font,
            fontSize: '15px',
          }}
        />
      ),
      nav: '/addnewinvoicetax',
    },
    {
      menu: 'listCustomer',
      label: ' Add Customer/Debitor',
      title: (
        <Typography marginLeft={-4} fontSize={'14px'}>
          Add Customer/Debtor
        </Typography>
      ),
      icon: (
        <AddIcon
          sx={{
            color: theme?.palette?.TmId.id.toString().includes('9') ? '' : theme.palette.input.font,
            fontSize: '15px',
          }}
        />
      ),
      nav: '/addcustomer',
    },
    {
      menu: 'addPos',
      label: 'Add POS',
      title: (
        <Typography marginLeft={-4} fontSize={'14px'}>
          Add POS
        </Typography>
      ),
      icon: (
        <AddIcon
          sx={{
            color: theme?.palette?.TmId.id.toString().includes('9') ? '' : theme.palette.input.font,
            fontSize: '15px',
          }}
        />
      ),
      nav: '/newpos',
    },
    {
      menu: 'addReceipt',
      label: 'List of Sales Invoice',
      title: (
        <Typography marginLeft={-4} fontSize={'14px'}>
          Sales Invoice List
        </Typography>
      ),
      icon: (
        <ListAltIcon
          sx={{
            color: theme?.palette?.TmId.id.toString().includes('9') ? '' : theme.palette.input.font,
            fontSize: '15px',
          }}
        />
      ),
      nav: '/salesInvoiceReport',
    },
    {
      menu: 'listReceipt',
      label: 'List of Customer/Debitor',
      title: (
        <Typography marginLeft={-4} fontSize={'14px'}>
          Customer/Debtor List
        </Typography>
      ),
      icon: (
        <ListAltIcon
          sx={{
            color: theme?.palette?.TmId.id.toString().includes('9') ? '' : theme.palette.input.font,
            fontSize: '15px',
          }}
        />
      ),
      nav: '/customerList',
    },
    {
      menu: 'listPos',
      label: 'List POS',
      title: (
        <Typography marginLeft={-4} fontSize={'14px'}>
          POS List
        </Typography>
      ),
      icon: (
        <ListAltIcon
          sx={{
            color: theme?.palette?.TmId.id.toString().includes('9') ? '' : theme.palette.input.font,
            fontSize: '15px',
          }}
        />
      ),
      nav: '/allpos',
    },
  ];
  const Purchase = [
    {
      menu: 'supplier',
      label: 'Add Purchase Invoice',
      title: (
        <Typography marginLeft={-4} fontSize={'14px'}>
          Add Purchase Invoice
        </Typography>
      ),
      icon: (
        <AddIcon
          sx={{
            color: theme?.palette?.TmId.id.toString().includes('9') ? '' : theme.palette.input.font,
            fontSize: '15px',
          }}
        />
      ),
      nav: '/addnewpurchasetax',
    },
    {
      menu: 'ListSupplier',
      label: ' Add Supplier/Creditor',
      title: (
        <Typography marginLeft={-4} fontSize={'14px'}>
          Add Supplier/Creditor
        </Typography>
      ),
      icon: (
        <AddIcon
          sx={{
            color: theme?.palette?.TmId.id.toString().includes('9') ? '' : theme.palette.input.font,
            fontSize: '15px',
          }}
        />
      ),
      nav: '/addsupplier',
    },
    {
      menu: 'addPayment',
      label: 'List of Purchase/Expense Bill',
      title: (
        <Typography marginLeft={-4} fontSize={'14px'}>
          Purchase/Expense Bill List
        </Typography>
      ),
      icon: (
        <ListAltIcon
          sx={{
            color: theme?.palette?.TmId.id.toString().includes('9') ? '' : theme.palette.input.font,
            fontSize: '15px',
          }}
        />
      ),
      nav: '/allpurchaseandexpense',
    },
    {
      menu: 'listPayment',
      label: '  List of Supplier/Creditor',
      title: (
        <Typography marginLeft={-4} fontSize={'14px'}>
          Supplier/Creditor List
        </Typography>
      ),
      icon: (
        <ListAltIcon
          sx={{
            color: theme?.palette?.TmId.id.toString().includes('9') ? '' : theme.palette.input.font,
            fontSize: '15px',
          }}
        />
      ),
      nav: '/supplierList',
    },
  ];
  const items = [
    {
      menu: 'addItem',
      label: 'Add Item',
      title: (
        <Typography marginLeft={-4} fontSize={'14px'}>
          Add Item
        </Typography>
      ),
      icon: (
        <AddIcon
          sx={{
            color: theme?.palette?.TmId.id.toString().includes('9') ? '' : theme.palette.input.font,
            fontSize: '15px',
          }}
        />
      ),
      nav: '/additem',
    },
    {
      menu: 'List',
      label: 'List Item',
      title: (
        <Typography marginLeft={-4} fontSize={'14px'}>
          Item List
        </Typography>
      ),
      icon: (
        <ListAltIcon
          sx={{
            color: theme?.palette?.TmId.id.toString().includes('9') ? '' : theme.palette.input.font,
            fontSize: '15px',
          }}
        />
      ),
      nav: '/newItemList',
    },
  ];
  // const user = [
  //   {
  //     menu: "addUser",
  //     title: (
  //       <Typography marginLeft={-4} fontSize={"14px"}>
  //         Add User
  //       </Typography>
  //     ),
  //     icon: (
  //       <PostAddIcon
  //         sx={{
  //           color: theme?.palette?.TmId.id.toString().includes("9")
  //             ? ""
  //             : theme.palette.input.font,
  //           fontSize: "15px",
  //         }}
  //       />
  //     ),
  //     nav: "",
  //   },
  //   {
  //     menu: "List",
  //     title: (
  //       <Typography marginLeft={-4} fontSize={"14px"}>
  //           List Users
  //       </Typography>
  //     ),
  //     icon: (
  //       <ListAltIcon
  //         sx={{
  //           color: theme?.palette?.TmId.id.toString().includes("9")
  //             ? ""
  //             : theme.palette.input.font,
  //           fontSize: "15px",
  //         }}
  //       />
  //     ),
  //     nav: "/newItemList",
  //   },

  // ]

  const others = [
    {
      menu: 'addjournalEntry',
      label: 'Add Journal Entry',
      title: (
        <Typography marginLeft={-4} fontSize={'14px'}>
          Add Journal Entry
        </Typography>
      ),
      icon: (
        <AddIcon
          sx={{
            color: theme?.palette?.TmId.id.toString().includes('9') ? '' : theme.palette.input.font,
            fontSize: '15px',
          }}
        />
      ),
      nav: '/addjournalentry',
    },
    {
      menu: 'Sales Order',
      label: 'List Journal Entry',
      title: (
        <Typography marginLeft={-4} fontSize={'14px'}>
          Journal Entry List
        </Typography>
      ),
      icon: (
        <ListAltIcon
          sx={{
            color: theme?.palette?.TmId.id.toString().includes('9') ? '' : theme.palette.input.font,
            fontSize: '15px',
          }}
        />
      ),
      nav: '/journalentries',
    },

    {
      menu: 'addOpeningBalance',
      label: 'Add Opening Balance',
      title: (
        <Typography marginLeft={-4} fontSize={'14px'}>
          Add/List Opening Balance
        </Typography>
      ),
      icon: (
        <AccountBalanceWalletIcon
          sx={{
            color: theme?.palette?.TmId.id.toString().includes('9') ? '' : theme.palette.input.font,
            fontSize: '15px',
          }}
        />
      ),
      nav: '/openingbalance',
    },
    // {
    //   menu: "List",
    //   title: (
    //     <Typography marginLeft={-4} fontSize={"14px"}>
    //         List Opening Balance
    //     </Typography>
    //   ),
    //   icon: (
    //     <ListAltIcon
    //       sx={{
    //         color: theme?.palette?.TmId.id.toString().includes("9")
    //           ? ""
    //           : theme.palette.input.font,
    //         fontSize: "15px",
    //       }}
    //     />
    //   ),
    //   nav: "",
    // },
    // {
    //   menu: "addLedger",
    //   title: (
    //     <Typography marginLeft={-4} fontSize={"14px"}>
    //       Add Ledger
    //     </Typography>
    //   ),
    //   icon: (
    //     <AddIcon
    //       sx={{
    //         color: theme?.palette?.TmId.id.toString().includes("9")
    //           ? ""
    //           : theme.palette.input.font,
    //         fontSize: "15px",
    //       }}
    //     />
    //   ),
    //   nav: "/accounts",
    // },
    // {
    //   menu: "ListLedger",
    //   title: (
    //     <Typography marginLeft={-4} fontSize={"14px"}>
    //         List Ledger
    //     </Typography>
    //   ),
    //   icon: (
    //     <ListAltIcon
    //       sx={{
    //         color: theme?.palette?.TmId.id.toString().includes("9")
    //           ? ""
    //           : theme.palette.input.font,
    //         fontSize: "15px",
    //       }}
    //     />
    //   ),
    //   nav: "/accounts",
    // },

    // {
    //   menu: "addGroup",
    //   title: (
    //     <Typography marginLeft={-4} fontSize={"14px"}>
    //       Add Group
    //     </Typography>
    //   ),
    //   icon: (
    //     <GroupAddIcon
    //       sx={{
    //         color: theme?.palette?.TmId.id.toString().includes("9")
    //           ? ""
    //           : theme.palette.input.font,
    //         fontSize: "15px",
    //       }}
    //     />
    //   ),
    //   nav: "/groups",
    // },
    // {
    //   menu: "ListLedger",
    //   title: (
    //     <Typography marginLeft={-4} fontSize={"14px"}>
    //         List Group
    //     </Typography>
    //   ),
    //   icon: (
    //     <ListAltIcon
    //       sx={{
    //         color: theme?.palette?.TmId.id.toString().includes("9")
    //           ? ""
    //           : theme.palette.input.font,
    //         fontSize: "15px",
    //       }}
    //     />
    //   ),
    //   nav: "/groups",
    // },
  ];

  const userMangament =[
    {
      menu: 'Adduser',
      label: 'User List',
      title: (
        <Typography marginLeft={-4} fontSize={'14px'}>
          User List
        </Typography>
      ),
      icon: (
        <AddIcon
          sx={{
            color: theme?.palette?.TmId.id.toString().includes('9') ? '' : theme.palette.input.font,
            fontSize: '15px',
          }}
        />
      ),
      nav: '/adduser/users',
    },
    {
      menu: 'Invitation',
      label: 'Make Invitation',
      title: (
        <Typography marginLeft={-4} fontSize={'14px'}>
          Make Invitation
        </Typography>
      ),
      icon: (
        <AddIcon
          sx={{
            color: theme?.palette?.TmId.id.toString().includes('9') ? '' : theme.palette.input.font,
            fontSize: '15px',
          }}
        />
      ),
      nav: '/adduser/invitations',
    },
    {
      menu: 'Join-Request',
      label: 'Join Request',
      title: (
        <Typography marginLeft={-4} fontSize={'14px'}>
          Join Request
        </Typography>
      ),
      icon: (
        <AddIcon
          sx={{
            color: theme?.palette?.TmId.id.toString().includes('9') ? '' : theme.palette.input.font,
            fontSize: '15px',
          }}
        />
      ),
      nav: '/adduser/join-requests',
    },

  ]
  const bulkImport = [
    {
      menu: 'itemImport',
      label: 'Item Import',
      title: (
        <Typography marginLeft={-4} fontSize={'14px'}>
          Item Import
        </Typography>
      ),
      icon: (
        <AddIcon
          sx={{
            color: theme?.palette?.TmId.id.toString().includes('9') ? '' : theme.palette.input.font,
            fontSize: '15px',
          }}
        />
      ),
      nav: '/newItemList',
      navState: { openImportModal: true },
    },
    {
      menu: 'customerImport',
      label: 'Customer Import',
      title: (
        <Typography marginLeft={-4} fontSize={'14px'}>
          Customer Import
        </Typography>
      ),
      icon: (
        <AddIcon
          sx={{
            color: theme?.palette?.TmId.id.toString().includes('9') ? '' : theme.palette.input.font,
            fontSize: '15px',
          }}
        />
      ),
      nav: '/customerList',
      navState: { openImportModal: true },
    },
    {
      menu: 'supplierImport',
      label: 'Supplier Import',
      title: (
        <Typography marginLeft={-4} fontSize={'14px'}>
          Supplier Import
        </Typography>
      ),
      icon: (
        <AddIcon
          sx={{
            color: theme?.palette?.TmId.id.toString().includes('9') ? '' : theme.palette.input.font,
            fontSize: '15px',
          }}
        />
      ),
      nav: '/supplierList',
      navState: { openImportModal: true },
    },
    {
      menu: 'accountImport',
      label: 'Account Import',
      title: (
        <Typography marginLeft={-4} fontSize={'14px'}>
          Account Import
        </Typography>
      ),
      icon: (
        <AddIcon
          sx={{
            color: theme?.palette?.TmId.id.toString().includes('9') ? '' : theme.palette.input.font,
            fontSize: '15px',
          }}
        />
      ),
      nav: '/accounts',
      navState: { openImportModal: true },
    },
  ];

  const bulkImportFlagByMenu = {
    itemImport: isItemImportEnabled,
    customerImport: isPartyImportEnabled,
    supplierImport: isPartyImportEnabled,
    accountImport: isAccountImportEnabled,
  };
  const enabledBulkImport = bulkImport.filter((item) => bulkImportFlagByMenu[item.menu]);

  const receiptVoucher = [
    {
      menu: 'AddReceipt',
      label: 'Add Receipt',
      title: (
        <Typography marginLeft={-4} fontSize={'14px'}>
          Add Receipt
        </Typography>
      ),
      icon: (
        <AddIcon
          sx={{
            color: theme?.palette?.TmId.id.toString().includes('9') ? '' : theme.palette.input.font,
            fontSize: '15px',
          }}
        />
      ),
      nav: '/addreceipts',
    },
    {
      menu: 'ReceiptList',
      label: 'List of Receipt',
      title: (
        <Typography marginLeft={-4} fontSize={'14px'}>
          Receipt List
        </Typography>
      ),
      icon: (
        <ListAltIcon
          sx={{
            color: theme?.palette?.TmId.id.toString().includes('9') ? '' : theme.palette.input.font,
            fontSize: '15px',
          }}
        />
      ),
      nav: '/receipts',
    },
  ];

  const paymentVoucher = [
    {
      menu: 'AddPayment',
      label: 'Add Payment',
      title: (
        <Typography marginLeft={-4} fontSize={'14px'}>
          Add Payment
        </Typography>
      ),
      icon: (
        <AddIcon
          sx={{
            color: theme?.palette?.TmId.id.toString().includes('9') ? '' : theme.palette.input.font,
            fontSize: '15px',
          }}
        />
      ),
      nav: '/addpaymententries',
    },
    {
      menu: 'List of Payments',
      label: 'List of Payments',
      title: (
        <Typography marginLeft={-4} fontSize={'14px'}>
          Payments List
        </Typography>
      ),
      icon: (
        <ListAltIcon
          sx={{
            color: theme?.palette?.TmId.id.toString().includes('9') ? '' : theme.palette.input.font,
            fontSize: '15px',
          }}
        />
      ),
      nav: '/paymententries',
    },
  ];
  const Bank = isBankImportEnabled
    ? [
        {
          menu: 'BankImport',
          label: 'Bank Import',
          title: (
            <Typography marginLeft={-4} fontSize={'14px'}>
              Bank Import
            </Typography>
          ),
          icon: (
            <AddIcon
              sx={{
                color: theme?.palette?.TmId.id.toString().includes('9')
                  ? ''
                  : theme.palette.input.font,
                fontSize: '15px',
              }}
            />
          ),
          nav: '/bankImport/',
        },
      ]
    : [];

  const debitAndCreditNote = [
    {
      menu: 'addDebitNote',
      label: ' Add Debit Note',
      title: (
        <Typography marginLeft={-4} fontSize={'14px'}>
          Add Debit Note
        </Typography>
      ),
      icon: (
        <AddIcon
          sx={{
            color: theme?.palette?.TmId.id.toString().includes('9') ? '' : theme.palette.input.font,
            fontSize: '15px',
          }}
        />
      ),
      nav: '/adddebitnote',
    },
    {
      menu: 'AddCreditNote',
      label: 'Add Credit Note',
      title: (
        <Typography marginLeft={-4} fontSize={'14px'}>
          Add Credit Note
        </Typography>
      ),
      icon: (
        <AddIcon
          sx={{
            color: theme?.palette?.TmId.id.toString().includes('9') ? '' : theme.palette.input.font,
            fontSize: '15px',
          }}
        />
      ),
      nav: '/addcreditnote',
    },
    {
      menu: 'ListOfDebitNOTE',
      label: ' List of Debit Note',
      title: (
        <Typography marginLeft={-4} fontSize={'14px'}>
          Debit Note List
        </Typography>
      ),
      icon: (
        <ListAltIcon
          sx={{
            color: theme?.palette?.TmId.id.toString().includes('9') ? '' : theme.palette.input.font,
            fontSize: '15px',
          }}
        />
      ),
      nav: '/alldebitnote',
    },
    {
      menu: 'ListOfCreditNote',
      label: 'List of Credit Note',
      title: (
        <Typography marginLeft={-4} fontSize={'14px'}>
          Credit Note List
        </Typography>
      ),
      icon: (
        <ListAltIcon
          sx={{
            color: theme?.palette?.TmId.id.toString().includes('9') ? '' : theme.palette.input.font,
            fontSize: '15px',
          }}
        />
      ),
      nav: '/allcreditnote',
    },
  ];

  const settings = [
    {
      menu: 'Customer',
      label: ' Voucher Settings',
      title: (
        <Typography marginLeft={-4} fontSize={'14px'}>
          Voucher Settings
        </Typography>
      ),
      icon: (
        <SettingsIcon
          sx={{
            color: theme?.palette?.TmId.id.toString().includes('9') ? '' : theme.palette.input.font,
            fontSize: '15px',
          }}
        />
      ),
      nav: '/defaultformats',
    },
    {
      menu: 'Customer',
      label: 'Email Settings',
      title: (
        <Typography marginLeft={-4} fontSize={'14px'}>
          Email Settings
        </Typography>
      ),
      icon: (
        <SettingsIcon
          sx={{
            color: theme?.palette?.TmId.id.toString().includes('9') ? '' : theme.palette.input.font,
            fontSize: '15px',
          }}
        />
      ),
      nav: '/emailsettings',
    },
    {
      menu: 'Customer',
      label: 'Invoice Print Settings',
      title: (
        <Typography marginLeft={-4} fontSize={'14px'}>
          Sales Invoice Print Settings
        </Typography>
      ),
      icon: (
        <SettingsIcon
          sx={{
            color: theme?.palette?.TmId.id.toString().includes('9') ? '' : theme.palette.input.font,
            fontSize: '15px',
          }}
        />
      ),
      nav: '/invoiceSettings',
    },
    {
      menu: 'Customer',
      label: 'Financial Year Settings',
      title: (
        <Typography marginLeft={-4} fontSize={'14px'}>
          Financial Year Settings
        </Typography>
      ),
      icon: (
        <SettingsIcon
          sx={{
            color: theme?.palette?.TmId.id.toString().includes('9') ? '' : theme.palette.input.font,
            fontSize: '15px',
          }}
        />
      ),
      nav: '/financialyearsettings',
    },
    {
      menu: 'Customer',
      label: 'GST,Tax Settings',
      title: (
        <Typography marginLeft={-4} fontSize={'14px'}>
          GST,Tax Settings
        </Typography>
      ),
      icon: (
        <SettingsIcon
          sx={{
            color: theme?.palette?.TmId.id.toString().includes('9') ? '' : theme.palette.input.font,
            fontSize: '15px',
          }}
        />
      ),
      nav: '/companysetup',
    },
    {
      menu: 'CompanyProfileSettings',
      label: 'Company Profile Settings',
      title: (
        <Typography marginLeft={-4} fontSize={'14px'}>
          Company Profile Settings
        </Typography>
      ),
      icon: (
        <SettingsIcon
          sx={{
            color: theme?.palette?.TmId.id.toString().includes('9') ? '' : theme.palette.input.font,
            fontSize: '15px',
          }}
        />
      ),
      nav: '/companysetup',
    },
    {
      menu: 'theme',
      label: ' Appearance',
      title: (
        <Typography marginLeft={-4} fontSize={'14px'}>
          Appearance
        </Typography>
      ),
      icon: (
        <ColorLensIcon
          sx={{
            color: theme?.palette?.TmId.id.toString().includes('9') ? '' : theme.palette.input.font,
            fontSize: '15px',
          }}
        />
      ),
      // nav: "/defaultformats",
    },
    {
      menu: 'warehouse',
      label: 'Ware house Details',
      title: (
        <Typography marginLeft={-4} fontSize={'14px'}>
          Ware House Details
        </Typography>
      ),
      icon: (
        <SettingsIcon
          sx={{
            color: theme?.palette?.TmId.id.toString().includes('9') ? '' : theme.palette.input.font,
            fontSize: '15px',
          }}
        />
      ),
      nav: '/warehouse',
    },
  ];

  const accountMenu = [
    {
      menu: 'revokeAiConsent',
      label: 'AI Consent',
      title: (
        <Typography marginLeft={-4} fontSize={'14px'}>
          Privacy & Policy
        </Typography>
      ),
      icon: (
        <SettingsIcon
          sx={{
            color: theme?.palette?.TmId.id.toString().includes('9') ? '' : theme.palette.input.font,
            fontSize: '15px',
          }}
        />
      ),
      nav: '/privacy-policy/',
    },
    {
      menu: 'deleteAccount',
      label: 'Delete Account',
      title: (
        <Typography marginLeft={-4} fontSize={'14px'}>
          Delete Account
        </Typography>
      ),
      icon: (
        <DeleteForeverIcon
          sx={{
            color: theme?.palette?.error?.main || '#d32f2f',
            fontSize: '15px',
          }}
        />
      ),
      nav: '/delete-account',
    },
  ];

  const extraLinks = [
    {
      menu: 'accounts',
      title: (
        <Typography fontSize={'14px'} fontWeight={'800'} marginLeft={-4}>
          Accounts
        </Typography>
      ),
      nav: '/accounts',
      label: 'Accounts',
      icon: (
        <AccountBalanceIcon
          sx={{
            color: theme?.palette?.TmId.id.toString().includes('9') ? '' : theme.palette.input.font,
            fontSize: '15px',
          }}
        />
      ),
    },
    {
      menu: 'reports',
      title: (
        <Typography fontSize={'14px'} fontWeight={'800'} marginLeft={-4}>
          Reports
        </Typography>
      ),
      nav: '/reports',
      label: 'Reports',
      icon: (
        <AssignmentIcon
          sx={{
            color: theme?.palette?.TmId.id.toString().includes('9') ? '' : theme.palette.input.font,
            fontSize: '15px',
          }}
        />
      ),
    },
    {
      menu: 'accounProfitLossts',
      title: (
        <Typography fontSize={'14px'} fontWeight={'800'} marginLeft={-4}>
          Profit & Loss
        </Typography>
      ),
      nav: '/?active=ProfitAndLoss',
      label: 'Profit & Loss',
      icon: (
        <TrendingUpIcon
          sx={{
            color: theme?.palette?.TmId.id.toString().includes('9') ? '' : theme.palette.input.font,
            fontSize: '15px',
          }}
        />
      ),
    },
    {
      menu: 'balanceSheet',
      title: (
        <Typography fontSize={'14px'} fontWeight={'800'} marginLeft={-4}>
          Balance Sheet
        </Typography>
      ),
      nav: '/?active=BalanceSheet',
      label: 'Balance Sheet',
      icon: (
        <BalanceIcon
          sx={{
            color: theme?.palette?.TmId.id.toString().includes('9') ? '' : theme.palette.input.font,
            fontSize: '15px',
          }}
        />
      ),
    },
    {
      menu: 'trialBalance',
      title: (
        <Typography fontSize={'14px'} fontWeight={'800'} marginLeft={-4}>
          Trial Balance
        </Typography>
      ),
      nav: '/?active=TrialBalance',
      label: 'Trial Balance',
      icon: (
        <SummarizeOutlinedIcon
          sx={{
            color: theme?.palette?.TmId.id.toString().includes('9') ? '' : theme.palette.input.font,
            fontSize: '15px',
          }}
        />
      ),
    },
    {
      menu: 'support',
      title: (
        <Typography fontSize={'14px'} fontWeight={'800'} marginLeft={-4}>
          Support
        </Typography>
      ),
      // nav: "/?active=TrialBalance",
      // label: "Trial Balance",
      icon: (
        <SupportAgentIcon
          sx={{
            color: theme?.palette?.TmId.id.toString().includes('9') ? '' : theme.palette.input.font,
            fontSize: '15px',
          }}
        />
      ),
    },
  ];

  const combainedArray = [
    ...sales,
    ...Purchase,
    ...items,
    ...others,
    ...userMangament,
    ...enabledBulkImport,
    ...receiptVoucher,
    ...paymentVoucher,
    ...Bank,
    ...debitAndCreditNote,
    ...settings,
    ...accountMenu,
    ...extraLinks,
  ];
  const filteredArray = combainedArray.filter((item) => item.label?.toLocaleUpperCase().includes(searchItem?.toLocaleUpperCase()));
  console.log(filteredArray.length, '===>lengthh');
  console.log(Boolean(searchItem), '===>Boolean');

  const filterdItems = (items, searchKey) => {
    if (!searchKey) return items;
    return items.filter((item) => item.label?.toLowerCase().includes(searchKey.toLowerCase()));
  };
  useEffect(() => {
    setLinkDrawer(false);
    return () => {};
  }, [window.location.href]);

  useEffect(() => {
    setSupportOpen(false);
  }, []);

  let [modalOpen, setModalOpen] = useState(false);
  const modalClose = (event, reason) => {
    if (reason !== 'backdropClick') {
      setModalOpen(false);
    }
  };

  return (
    <>
      <SelectTheme isOpen={modalOpen} onClose={modalClose} setModalopen={setModalOpen} />
      <SupportPage open={supportOpen} setOpen={setSupportOpen} />
      {linkDrawer && (
        <SwipeableDrawer
          anchor="right"
          open={linkDrawer}
          onClose={() => {
            setLinkDrawer(false);
            setSearchItem('');
            setExpand(false);
            setAccountsExpand(false);
          }}
          onOpen={() => setLinkDrawer(true)}
        >
          <Box
            sx={{
              padding: { xs: '10px', sm: '30px' },
              paddingTop: { xs: '10px', sm: '5px' },
              paddingBottom: { xs: '10px', sm: '5px' },
              width: { xs: '250px', sm: '420px' },
            }}
            role="presentation"
          >
            <Box
              sx={{
                display: 'flex',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  width: '50%',
                }}
              >
                <KeyboardBackspace
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    setLinkDrawer(false);
                    setSearchItem('');
                  }}
                  sx={{ fontSize: '30px', marginRight: 1, fontWeight: '0' }}
                />
                <Typography fontWeight={600} fontSize="18px">
                  Quick Links
                </Typography>
              </Box>

              <Paper
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  width: '50%',
                  border: ' 1px solid #C0C0C0',
                  boxShadow: 'none',
                  marginTop: '15px',
                  marginBottom: '15px',
                }}
              >
                <InputBase
                  sx={{ ml: 1, flex: 1 }}
                  placeholder="Search"
                  inputProps={{ 'aria-label': 'search google maps' }}
                  onChange={(e) => setSearchItem(e.target.value)}
                />
                <IconButton type="button" sx={{ padding: '8px 10px' }} aria-label="search">
                  <Search />
                </IconButton>
              </Paper>
            </Box>

            {/* <List
              sx={{
                ".css-1nx70b6-MuiButtonBase-root-MuiListItemButton-root": {
                  padding: "8px 10px",
                },
              }}
            >
              <Typography
                marginBottom={"10px"}
                fontWeight={600}
                fontSize="16px"
              >
                General
              </Typography>
              <Grid
                container
                rowSpacing={1}
                columnSpacing={{ xs: 1, sm: 2, md: 3 }}
              >
                {general.map((item, index) => (
                  <Link
                    style={{
                      width: "50%",
                      textDecoration: "none",
                      color: theme.palette.input.font,
                    }}
                    // key={index} disablePadding
                    to={item.nav}
                  >
                    <ListItemButton>
                      <ListItemIcon>{item.icon}</ListItemIcon>
                      <ListItemText
                        sx={{
                          color: theme?.palette?.TmId.id
                            .toString()
                            .includes("9")
                            ? ""
                            : theme.palette.input.font,
                        }}
                        primary={item.title}
                      />
                    </ListItemButton>
                  </Link>
                ))}
              </Grid>
            </List> */}

            <Grid container spacing={1} sx={{ xs: { marginTop: '0px' }, sm: { marginTop: '-5px' } }}>
              <Grid
                item
                xs={12}
                sm={6}
                sx={{
                  marginTop: { xs: '0px', sm: '-20px' },
                  minHeight: '70px',
                }}
              >
                <List
                  sx={{
                    '.css-1nx70b6-MuiButtonBase-root-MuiListItemButton-root': {
                      padding: '8px 10px',
                    },
                    marginTop: '5px',
                  }}
                >
                  <Typography marginBottom="10px" fontWeight={600} fontSize="16px">
                    Sales
                  </Typography>

                  {filterdItems(sales, searchItem).map((item, index) => (
                    <Link
                      key={index}
                      onClick={(e) => {
                        e.preventDefault();
                        navigate(item.nav);
                        setLinkDrawer(false);
                      }}
                      style={{
                        textDecoration: 'none',
                        color: theme.palette.input.font,
                        padding: 0,
                        marginTop: '5px',
                        display: 'block',
                      }}
                    >
                      <ListItemButton sx={{ padding: 0 }}>
                        <ListItemIcon>{item.icon}</ListItemIcon>
                        <ListItemText
                          sx={{
                            color: 'blue',
                            textWrap: 'nowrap',
                          }}
                          primary={item.title}
                        />
                      </ListItemButton>
                    </Link>
                  ))}
                </List>
              </Grid>

              <Grid
                item
                xs={12}
                sm={6}
                sx={{
                  marginTop: { xs: '0px', sm: '-20px' },
                  minHeight: '70px',
                }}
              >
                <List
                  sx={{
                    '.css-1nx70b6-MuiButtonBase-root-MuiListItemButton-root': {
                      padding: '8px 10px',
                    },
                    marginTop: '5px',
                  }}
                >
                  <Typography marginBottom={'10px'} fontWeight={600} fontSize="16px">
                    Purchase/Expense
                  </Typography>
                  {/* <Grid
                container
                rowSpacing={1}
                columnSpacing={{ xs: 1, sm: 2, md: 3 }}
              > */}
                  {filterdItems(Purchase, searchItem).map((item, index) => (
                    <Link
                      style={{
                        // width: "50%",
                        textDecoration: 'none',
                        color: theme.palette.input.font,
                        padding: 0,
                        marginTop: '5px',
                        display: 'block',
                      }}
                      // to={item.nav}
                      key={index}
                      disablePadding
                      onClick={(e) => {
                        e.preventDefault();
                        navigate(item.nav);
                        setLinkDrawer(false);
                      }}
                    >
                      <ListItemButton sx={{ padding: 0 }}>
                        <ListItemIcon>
                          {item.icon}
                          {/* <ListItemText sx={{ color: '#b5b5b5',  }} primary={item.icon} /> */}
                        </ListItemIcon>
                        <ListItemText
                          sx={{
                            // color: theme?.palette?.TmId.id
                            //   .toString()
                            //   .includes("9")
                            //   ? ""
                            //   : theme.palette.input.font,
                            color: 'blue',
                            textWrap: 'nowrap',
                          }}
                          primary={item.title}
                        />
                      </ListItemButton>
                    </Link>
                  ))}
                  {/* </Grid> */}
                </List>
              </Grid>

              <Grid
                item
                xs={12}
                sm={6}
                sx={{
                  marginTop: { xs: '0px', sm: '-20px' },
                  minHeight: '70px',
                }}
              >
                <List
                  sx={{
                    '.css-1nx70b6-MuiButtonBase-root-MuiListItemButton-root': {
                      padding: '8px 10px',
                    },
                    marginTop: '5px',
                  }}
                >
                  <Typography marginBottom={'10px'} fontWeight={600} fontSize="16px">
                    Receipt Voucher
                  </Typography>

                  {filterdItems(receiptVoucher, searchItem).map((item, index) => (
                    <Link
                      key={index}
                      // to={item.nav}
                      onClick={(e) => {
                        e.preventDefault();
                        navigate(item.nav);
                        setLinkDrawer(false);
                      }}
                      style={{
                        textDecoration: 'none',
                        color: theme.palette.input.font,
                        padding: 0,
                        marginTop: '5px',
                        display: 'block',
                      }}
                    >
                      <ListItemButton sx={{ padding: 0 }}>
                        <ListItemIcon>{item.icon}</ListItemIcon>
                        <ListItemText
                          sx={{
                            // color: theme?.palette?.TmId.id
                            //   .toString()
                            //   .includes("9")
                            //   ? ""
                            //   : theme.palette.input.font,
                            color: 'blue',
                            textWrap: 'nowrap',
                          }}
                          primary={item.title}
                        />
                      </ListItemButton>
                    </Link>
                  ))}
                </List>
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                sx={{
                  marginTop: { xs: '0px', sm: '-20px' },
                  minHeight: '70px',
                }}
              >
                <List
                  sx={{
                    '.css-1nx70b6-MuiButtonBase-root-MuiListItemButton-root': {
                      padding: '8px 10px',
                    },
                    marginTop: '5px',
                  }}
                >
                  <Typography marginBottom={'10px'} fontWeight={600} fontSize="16px">
                    Payment Voucher
                  </Typography>
                  {/* <Grid
                container
                rowSpacing={1}
                columnSpacing={{ xs: 1, sm: 2, md: 3 }}
              > */}
                  {filterdItems(paymentVoucher, searchItem).map((item, index) => (
                    <Link
                      style={{
                        // width: "50%",
                        textDecoration: 'none',
                        color: theme.palette.input.font,
                        padding: 0,
                        marginTop: '5px',
                        display: 'block',
                      }}
                      // to={item.nav}
                      key={index}
                      disablePadding
                      onClick={(e) => {
                        e.preventDefault();
                        navigate(item.nav);
                        setLinkDrawer(false);
                      }}
                    >
                      <ListItemButton sx={{ padding: 0 }}>
                        <ListItemIcon>
                          {item.icon}
                          {/* <ListItemText sx={{ color: '#b5b5b5',  }} primary={item.icon} /> */}
                        </ListItemIcon>
                        <ListItemText
                          sx={{
                            // color: theme?.palette?.TmId.id
                            //   .toString()
                            //   .includes("9")
                            //   ? ""
                            //   : theme.palette.input.font,
                            color: 'blue',
                            textWrap: 'nowrap',
                          }}
                          primary={item.title}
                        />
                      </ListItemButton>
                    </Link>
                  ))}
                  {/* </Grid> */}
                </List>
              </Grid>
             

              <Grid
                item
                xs={12}
                sm={6}
                sx={{
                  marginTop: { xs: '0px', sm: searchItem ? '0px' : '-20px' },
                  minHeight: '70px',
                }}
              >
                <List
                  sx={{
                    '.css-1nx70b6-MuiButtonBase-root-MuiListItemButton-root': {
                      padding: '8px 10px',
                    },
                    marginTop: '5px',
                  }}
                >
                  <Typography marginBottom={'10px'} fontWeight={600} fontSize="16px">
                    Item
                  </Typography>

                  {filterdItems(items, searchItem).map((item, index) => (
                    <Link
                      key={index}
                      // to={item.nav}
                      onClick={(e) => {
                        e.preventDefault();
                        navigate(item.nav);
                        setLinkDrawer(false);
                      }}
                      style={{
                        textDecoration: 'none',
                        color: theme.palette.input.font,
                        padding: 0,
                        marginTop: '5px',
                        display: 'block',
                      }}
                    >
                      <ListItemButton sx={{ padding: 0 }}>
                        <ListItemIcon>{item.icon}</ListItemIcon>
                        <ListItemText
                          sx={{
                            // color: theme?.palette?.TmId.id
                            //   .toString()
                            //   .includes("9")
                            //   ? ""
                            //   : theme.palette.input.font,
                            color: 'blue',
                            textWrap: 'nowrap',
                          }}
                          primary={item.title}
                        />
                      </ListItemButton>
                    </Link>
                  ))}
                </List>
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                sx={{
                  marginTop: { xs: '0px', sm: searchItem ? '0px' : '-20px' },
                  minHeight: '70px',
                }}
              >
                <List
                  sx={{
                    '.css-1nx70b6-MuiButtonBase-root-MuiListItemButton-root': {
                      padding: '8px 10px',
                    },
                    marginTop: '5px',
                  }}
                >
                  <Typography marginBottom={'10px'} fontWeight={600} fontSize="16px">
                    Debit/Credit Notes
                  </Typography>
                  {/* <Grid

              <Grid item xs={12} sm={6} sx={{marginTop: { xs: "0px", sm: "-20px" }}}>
                <List
                  sx={{
                    ".css-1nx70b6-MuiButtonBase-root-MuiListItemButton-root": {
                      padding: "8px 10px",
                    },
                    marginTop: "5px",
                  }}
                >
                  <Typography
                    marginBottom={"10px"}
                    fontWeight={600}
                    fontSize="16px"
                  >
                    Item
                  </Typography>

                  {items.map((item, index) => (
                    <Link
                      key={index}
                      to={item.nav}
                      onClick={() => {
                        navigate(item.nav);
                        setLinkDrawer(false);
                      }}
                      style={{
                        textDecoration: "none",
                        color: theme.palette.input.font,
                        padding: 0,
                        marginTop: "5px",
                        display: "block",
                      }}
                    >
                      <ListItemButton sx={{ padding: 0 }}>
                        <ListItemIcon>{item.icon}</ListItemIcon>
                        <ListItemText
                          sx={{
                            // color: theme?.palette?.TmId.id
                            //   .toString()
                            //   .includes("9")
                            //   ? ""
                            //   : theme.palette.input.font,
                            color:"blue",
                            textWrap: "nowrap",
                          }}
                          primary={item.title}
                        />
                      </ListItemButton>
                    </Link>
                  ))}
                </List>
              </Grid>
              <Grid item xs={12} sm={6} sx={{marginTop: { xs: "0px", sm: "-20px" }}}>
                <List
                  sx={{
                    ".css-1nx70b6-MuiButtonBase-root-MuiListItemButton-root": {
                      padding: "8px 10px",
                    },
                    marginTop: "5px",
                  }}
                >
                  <Typography
                    marginBottom={"10px"}
                    fontWeight={600}
                    fontSize="16px"
                  >
                    Debit/Credit Notes
                  </Typography>
                  {/* <Grid
                container
                rowSpacing={1}
                columnSpacing={{ xs: 1, sm: 2, md: 3 }}
              > */}
                  {filterdItems(debitAndCreditNote, searchItem).map((item, index) => (
                    <Link
                      style={{
                        // width: "50%",
                        textDecoration: 'none',
                        color: theme.palette.input.font,
                        padding: 0,
                        marginTop: '5px',
                        display: 'block',
                      }}
                      // to={item.nav}
                      key={index}
                      disablePadding
                      onClick={(e) => {
                        e.preventDefault();
                        navigate(item.nav);
                        setLinkDrawer(false);
                      }}
                    >
                      <ListItemButton sx={{ padding: 0 }}>
                        <ListItemIcon>
                          {item.icon}
                          {/* <ListItemText sx={{ color: '#b5b5b5',  }} primary={item.icon} /> */}
                        </ListItemIcon>
                        <ListItemText
                          sx={{
                            // color: theme?.palette?.TmId.id
                            //   .toString()
                            //   .includes("9")
                            //   ? ""
                            //   : theme.palette.input.font,
                            color: 'blue',
                            textWrap: 'nowrap',
                          }}
                          primary={item.title}
                        />
                      </ListItemButton>
                    </Link>
                  ))}
                  {/* </Grid> */}
                </List>
              </Grid>

              <Grid
                item
                xs={12}
                sm={6}
                sx={{
                  marginTop: { xs: '0px', sm: searchItem ? '0px' : '-80px' },
                  minHeight: '70px',
                }}
              >
                <List
                  sx={{
                    '.css-1nx70b6-MuiButtonBase-root-MuiListItemButton-root': {
                      padding: '8px 10px',
                    },
                    marginTop: '5px',
                  }}
                >
                  <Typography marginBottom={'10px'} fontWeight={600} fontSize="16px">
                    Other vouchers
                  </Typography>
                  {/* <Grid
                container
                rowSpacing={1}
                columnSpacing={{ xs: 1, sm: 2, md: 3 }}
              > */}
                  {filterdItems(others, searchItem).map((item, index) => (
                    <Link
                      style={{
                        // width: "50%",
                        textDecoration: 'none',
                        color: theme.palette.input.font,
                        padding: 0,
                        marginTop: '5px',
                        display: 'block',
                      }}
                      // to={item.nav}
                      key={index}
                      disablePadding
                      onClick={(e) => {
                        e.preventDefault();
                        navigate(item.nav);
                        setLinkDrawer(false);
                      }}
                    >
                      <ListItemButton sx={{ padding: 0 }}>
                        <ListItemIcon>
                          {item.icon}
                          {/* <ListItemText sx={{ color: '#b5b5b5',  }} primary={item.icon} /> */}
                        </ListItemIcon>
                        <ListItemText
                          sx={{
                            // color: theme?.palette?.TmId.id
                            //   .toString()
                            //   .includes("9")
                            //   ? ""
                            //   : theme.palette.input.font,
                            color: 'blue',
                            textWrap: 'nowrap',
                          }}
                          primary={item.title}
                        />
                      </ListItemButton>
                    </Link>
                  ))}
                  {/* </Grid> */}
                </List>
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                sx={{
                  marginTop: { xs: '0px', sm: '-20px' },
                  minHeight: '70px',
                }}
              >
                <Accordion
                  expanded={searchItem || accountsExpand}
                  onChange={() => setAccountsExpand((prev) => !prev)}
                  sx={{ margin: '0px' }}
                >
                  <AccordionSummary
                    sx={{
                      padding: 0,
                      '& .MuiAccordionSummary-content': {
                        margin: 0,
                      },
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '20px',
                      }}
                    >
                      <Typography fontWeight={600} fontSize="16px">
                        Privacy & Data
                      </Typography>
                      {searchItem || accountsExpand ? (
                        <ExpandLessIcon sx={{ color: 'blue' }} />
                      ) : (
                        <ExpandMoreIcon sx={{ color: 'blue' }} />
                      )}
                    </Box>
                  </AccordionSummary>

                  <AccordionDetails sx={{ margin: '0px', padding: 0 }}>
                    {filterdItems(accountMenu, searchItem).map((item, index) => (
                      <Link
                        key={index}
                        onClick={(e) => {
                          e.preventDefault();
                          navigate(item.nav);
                          setLinkDrawer(false);
                          setAccountsExpand(false);
                        }}
                        style={{
                          textDecoration: 'none',
                          color: theme.palette.input.font,
                          padding: 0,
                          marginTop: '5px',
                          display: 'block',
                        }}
                      >
                        <ListItemButton sx={{ padding: 0 }}>
                          <ListItemIcon>{item.icon}</ListItemIcon>
                          <ListItemText
                            sx={{
                              color: 'blue',
                              textWrap: 'nowrap',
                            }}
                            primary={item.title}
                          />
                        </ListItemButton>
                      </Link>
                    ))}
                  </AccordionDetails>
                </Accordion>
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                sx={{
                  marginTop: { xs: '0px', sm: '-20px' },
                  minHeight: '70px',
                }}
              >
                <Accordion expanded={searchItem || expand} onChange={() => setExpand((prev) => !prev)} sx={{ margin: '0px' }}>
                  <AccordionSummary
                    // expandIcon={<ExpandMoreIcon sx={{ color: "blue" }} />}
                    sx={{
                      padding: 0,
                      // minHeight: "auto",
                      '& .MuiAccordionSummary-content': {
                        margin: 0,
                      },
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '20px',
                      }}
                    >
                      <Typography fontWeight={600} fontSize="16px">
                        Settings
                      </Typography>
                      {searchItem || expand ? <ExpandLessIcon sx={{ color: 'blue' }} /> : <ExpandMoreIcon sx={{ color: 'blue' }} />}
                    </Box>
                  </AccordionSummary>

                  <AccordionDetails sx={{ margin: '0px' }}>
                    {filterdItems(settings, searchItem).map((item, index) => (
                      <Box
                        key={index}
                        sx={{
                          textDecoration: 'none',
                          color: theme.palette.input.font,
                          // padding: "8px 10px",
                          marginTop: '5px',
                          display: 'flex',
                          alignItems: 'center',
                          cursor: 'pointer',
                        }}
                        onClick={() => {
                          if (item.menu === 'theme') {
                            setModalOpen(true);
                            setExpand(false);
                          } else {
                            // Navigate to specific step in newCompanySetup
                            if (item.title.props.children === 'Company Profile Settings') {
                              navigate('/companysetup', { state: { activeValue: 0 } });
                            } else if (item.title.props.children === 'GST,Tax Settings') {
                              navigate('/companysetup', { state: { activeValue: 1 } });
                            } else {
                              navigate(item.nav);
                            }
                          }

                          setLinkDrawer(false);
                          setExpand(false);
                        }}
                      >
                        <ListItemIcon>{item.icon}</ListItemIcon>
                        <ListItemText
                          sx={{
                            color: 'blue',
                            textWrap: 'nowrap',
                          }}
                          primary={item.title}
                        />
                      </Box>
                    ))}
                  </AccordionDetails>
                </Accordion>
              </Grid>

                <Grid
                item
                xs={12}
                sm={6}
                sx={{
                  marginTop: { xs: '0px', sm: '-20px' },
                  minHeight: '70px',
                }}
              >
                <List
                  sx={{
                    '.css-1nx70b6-MuiButtonBase-root-MuiListItemButton-root': {
                      padding: '8px 10px',
                    },
                    marginTop: '5px',
                  }}
                >
                  <Typography marginBottom={'10px'} fontWeight={600} fontSize="16px">
                    User Mangement
                  </Typography>

                  {filterdItems(userMangament, searchItem).map((item, index) => (
                    <Link
                      key={index}
                      // to={item.nav}
                      onClick={(e) => {
                        e.preventDefault();
                        navigate(item.nav);
                        setLinkDrawer(false);
                      }}
                      style={{
                        textDecoration: 'none',
                        color: theme.palette.input.font,
                        padding: 0,
                        marginTop: '5px',
                        display: 'block',
                      }}
                    >
                      <ListItemButton sx={{ padding: 0 }}>
                        <ListItemIcon>{item.icon}</ListItemIcon>
                        <ListItemText
                          sx={{
                            // color: theme?.palette?.TmId.id
                            //   .toString()
                            //   .includes("9")
                            //   ? ""
                            //   : theme.palette.input.font,
                            color: 'blue',
                            textWrap: 'nowrap',
                          }}
                          primary={item.title}
                        />
                      </ListItemButton>
                    </Link>
                  ))}
                </List>
              </Grid>

              <Grid
                item
                xs={12}
                sm={6}
                sx={
                  {
                    // marginTop: { xs: "0px", sm: searchItem ? "-200px" : "0px" },
                  }
                }
              >
                <List
                  sx={{
                    '.css-1nx70b6-MuiButtonBase-root-MuiListItemButton-root': {
                      padding: '8px 10px',
                    },
                    marginTop: '5px',
                  }}
                >
                  {enabledBulkImport.length > 0 && (
                    <Typography marginBottom={'10px'} fontWeight={600} fontSize="16px">
                      Bulk Import
                    </Typography>
                  )}
                  {filterdItems(enabledBulkImport, searchItem).map((item, index) => (
                    <Link
                      style={{
                        textDecoration: 'none',
                        color: theme.palette.input.font,
                        padding: 0,
                        marginTop: '5px',
                        display: 'block',
                      }}
                      key={index}
                      disablePadding
                      onClick={(e) => {
                        e.preventDefault();
                        handleBulkImportClick(item);
                      }}
                    >
                      <ListItemButton sx={{ padding: 0 }}>
                        <ListItemIcon>{item.icon}</ListItemIcon>
                        <ListItemText
                          sx={{
                            color: 'blue',
                            textWrap: 'nowrap',
                          }}
                          primary={item.title}
                        />
                      </ListItemButton>
                    </Link>
                  ))}
                </List>
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                sx={
                  {
                    // marginTop: { xs: "0px", sm: searchItem ? "-200px" : "0px" },
                  }
                }
              >
                <List
                  sx={{
                    '.css-1nx70b6-MuiButtonBase-root-MuiListItemButton-root': {
                      padding: '8px 10px',
                    },
                    marginTop: '5px',
                  }}
                >
                  {filterdItems(extraLinks, searchItem).map((item, index) => (
                    <Link
                      style={{
                        textDecoration: 'none',
                        color: theme.palette.input.font,
                        padding: 0,
                        marginTop: '5px',
                        display: 'block',
                      }}
                      key={index}
                      disablePadding
                      onClick={(e) => {
                        if (item.menu === 'support') {
                          setSupportOpen(true);
                          setLinkDrawer(false);
                        } else {
                          e.preventDefault();
                          navigate(item.nav);
                          setLinkDrawer(false);
                        }
                      }}
                    >
                      <ListItemButton sx={{ padding: 0 }}>
                        <ListItemIcon>
                          <ListItemText sx={{ color: '#b5b5b5' }} primary={item.icon} />
                        </ListItemIcon>
                        <ListItemText
                          sx={{
                            color: 'blue',
                            textWrap: 'nowrap',
                          }}
                          primary={item.title}
                        />
                      </ListItemButton>
                    </Link>
                  ))}
                </List>
              </Grid>
              {isBankImportEnabled && (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  sx={{
                    marginTop: { xs: '0px', sm: '-20px' },
                    minHeight: '70px',
                  }}
                >
                  <List
                    sx={{
                      '.css-1nx70b6-MuiButtonBase-root-MuiListItemButton-root': {
                        padding: '8px 10px',
                      },
                      marginTop: '5px',
                    }}
                  >
                    <Typography marginBottom={'10px'} fontWeight={600} fontSize="16px">
                      Bank Import
                    </Typography>
                    {filterdItems(Bank, searchItem).map((item, index) => (
                      <Link
                        style={{
                          textDecoration: 'none',
                          color: theme.palette.input.font,
                          padding: 0,
                          marginTop: '5px',
                          display: 'block',
                        }}
                        key={index}
                        disablePadding
                        onClick={(e) => {
                          e.preventDefault();
                          navigate(item.nav);
                          setLinkDrawer(false);
                        }}
                      >
                        <ListItemButton sx={{ padding: 0 }}>
                          <ListItemIcon>{item.icon}</ListItemIcon>
                          <ListItemText
                            sx={{
                              color: 'blue',
                              textWrap: 'nowrap',
                            }}
                            primary={item.title}
                          />
                        </ListItemButton>
                      </Link>
                    ))}
                  </List>
                </Grid>
              )}
              <Grid
                item
                xs={12}
                sm={6}
                sx={{
                  marginTop: { xs: '0px', sm: '-20px' },
                  minHeight: '70px',
                }}
              >
                {/* <Accordion sx={{ margin: "0px" }}> */}
                {/* <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{ color: "blue" }} />}
                    sx={{
                      padding: 0,
                      "& .MuiAccordionSummary-content": {
                        margin: 0,
                      },
                    }}
                  > */}
                <Typography fontWeight={600} fontSize="16px" marginTop={'10px'}>
                  Notification Settings
                </Typography>
                {/* </AccordionSummary> */}

                {/* <AccordionDetails sx={{ margin: "0px" }}></AccordionDetails> */}
                {/* </Accordion> */}
              </Grid>
            </Grid>
          </Box>
        </SwipeableDrawer>
      )}
    </>
  );
}

export default LinkDrawer;
